
export default {
    props: {
        'name': String,
        value: [String, Number],
        'id': String,
        'disabled': Boolean,
        'required': Boolean,
        label: String,
        hasDescription: {
            type: Boolean,
            default: true
        },
        ratingDescription: {
            type: Array,
            default: () => {
                return [
                    {
                        text: "Notez",
                        class: "star-nothing"
                    },
                    {
                        text: "Horrible",
                        class: "star-poor"
                    },
                    {
                        text: "Médiocre",
                        class: "star-belowAverage"
                    },
                    {
                        text: "Moyen",
                        class: "star-average"
                    },
                    {
                        text: "Bien",
                        class: "star-good"
                    },
                    {
                        text: "Excellent",
                        class: "star-excellent"
                    }
                ];
            },
        },
    },
    data: function() {
        return {
            temp_value: this.value,
            ratings: [1, 2, 3, 4, 5],
            starDescription : this.ratingDescription[this.value]
        };
    },
    methods: {
        starOver: function(value) {
            if (!this.disabled) {
                this.starDescription = this.ratingDescription[value];
                return this.$emit('input', value);
            }
        },
        starOut: function() {
            if (!this.disabled) {
                if (! this.temp_value) {
                    this.starDescription = this.ratingDescription[0];
                }
                else {
                    this.starDescription = this.ratingDescription[this.temp_value];
                }
                return this.$emit('input', this.temp_value);
            }
        },
        set: function(value) {
            if (!this.disabled) {
                this.temp_value = value;
                return this.$emit('update:input', value);
            }
        },
    }
}
